// extracted by mini-css-extract-plugin
export default {"lowContainer":"Main_lowContainer__8ubBv"};